import axiosClient from "./axiosClient";

// --- Emergency Contacts API ---

// Get all emergency contacts
export const getEmergencyContacts = () => axiosClient.get("/emergency-contacts");

// Create a new emergency contact
// data example: { phone: "0912345678" }
export const createEmergencyContact = (data) =>
  axiosClient.post("/emergency-contacts", data);

// Update an existing emergency contact by ID
// data example: { phone: "0987654321" }
export const updateEmergencyContact = (id, data) =>
  axiosClient.put(`/emergency-contacts/${id}`, data);

// Delete an emergency contact by ID
export const deleteEmergencyContact = (id) =>
  axiosClient.delete(`/emergency-contacts/${id}`);
